import React from 'react';
import StartNow from '../../../Common-components/start-now/StartNow';
import "./Solutions.css";
import background from '../../Assets/background_images/background1.png';

const LeadershipProfile = () => {
    return (
        <div>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
        <img className='image' src={background} alt='hiring' />
        <div className='heading'>Leadership Profile</div>
        </div>
 
     <div> 
       <h1 className='title'>What is the LP ?</h1> 
       <p className='paragraph'>The Leadership Profile (LP) guides the hiring, placement, and development of your organization's most highly valued resource – its leaders. This advanced assessment complements our other core solutions by providing a more in-depth leadership analysis of both current employees and new candidates. Investing in tailored leadership development programmes for your high-potential employees leads to higher attrition, efficiency, involvement, customer happiness, and profitability.</p>
     </div> 
     <hr />

     <div> 
       <h1 className='title'>How Does It Work?</h1> 
       <p className='paragraph'>The Leadership Profile (LP) guides the hiring, placement, and development of your organization's most highly valued resource – its leaders. This advanced assessment complements our other core solutions by providing a more in-depth leadership analysis of both current employees and new candidates. Investing in tailored leadership development programmes for your high-potential employees leads to higher attrition, efficiency, involvement, customer happiness, and profitability.</p>
       <ul className='outer-list'>
            <li>Workplace Culture and Performance Profile.</li>
            <li>Reasoning in Business (verbal & numerical problem solving).</li>
            <li>Style of Conflict Resolution (with supervisors, direct reports and peers).</li>
        </ul>
     </div> 
     <hr />

     <div> 
       <h1 className='title'>Benefits of Using the LP</h1> 
       <ul className='outer-list'>
          <li>Assess leadership potential so that you may invest in today's and tomorrow's leaders.</li>
          <li>Recognize how leaders will 'fit' into certain positions and teams.</li>
          <li>Find and cultivate top global talent to help your company thrive.</li>
          <li>Gain insight into your natural leadership style, strengths, and weaknesses in order to provide tailored and meaningful development programmes.</li>
          <li>Determine any potential threats or areas of concern.</li>
          <li>Increase retention, productivity, team quality, and profitability.</li>
        </ul>

       <p className='paragraph'>Identify NEW leaders throughout the pre-recruitment process:</p>
       <ul className='outer-list'>
       <li> Assessing new applications allows you to quickly find high-potential leaders to assist you develop your firm. </li>
        </ul>
       <p className='paragraph'>Develop and retain Established leaders in your institution:</p>
       <ul className='outer-list'>
       <li>Customized development and mentoring programmes that encourage you to invest in your organization's finest leaders.</li>
        </ul>
       <p className='paragraph'>Empower FUTURE leaders for efficient succession planning:</p>
       <ul className='outer-list'>
       <li>Plan for the future and discover internal and external personnel who are the greatest match for your leadership opportunities.</li>
        </ul>
     </div> 

     <div>
     <h1 className='title'>Leadership Profile Plus (LP+)</h1> 
     <p className='paragraph'> The Leadership Profile Plus (LP+) has all of the advantages of the Leadership Profile as well as Work Values and Tolerance For Risk, and the Employer Assessment includes a Leadership Fit Score. Begin by attempting the LP+ for yourself right now! </p>
     </div>



     <div style={{textAlign:'center'}}>
       <StartNow/>
     </div>

     </div>
    )
}
 
export default LeadershipProfile;